import React from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import '../NicheLanding/NicheLandingPage.css';

const featureIcons = [
    // Invoice / document icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>,
    // Dashboard / tracking icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
    </svg>,
    // Payment / wallet icon
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>,
];

function Features(){
    const { t } = useLocale();

    const features = [
        { id: 1, icon: featureIcons[0], title: t('freelancers.sectionOneTitle'), description: t('freelancers.sectionOneDescription') },
        { id: 2, icon: featureIcons[1], title: t('freelancers.sectionTwoTitle'), description: t('freelancers.sectionTwoDescription') },
        { id: 3, icon: featureIcons[2], title: t('freelancers.sectionThreeTitle'), description: t('freelancers.sectionThreeDescription') },
    ];

    return(
        <>
            {/* Features */}
            <section className="niche-features sp-90">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <h2 className="h-1 h-bold mb-20">
                                {t('freelancers.featuresTitleStart')}{' '}{t('freelancers.featuresTitleEnd')}
                            </h2>
                            <p className="niche-feature-desc" style={{ maxWidth: '600px', margin: '0 auto 20px' }}>
                                {t('freelancers.introOne')}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {features.map(f => (
                            <div className="col-lg-4" key={f.id}>
                                <div className="niche-feature-card">
                                    <div className="niche-feature-icon">{f.icon}</div>
                                    <h3 className="niche-feature-title">{f.title}</h3>
                                    <p className="niche-feature-desc">{f.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="niche-cta-section sp-90">
                <div className="container">
                    <h2 className="h-1 h-bold niche-cta-title">
                        {t('freelancers.ctaTitle')}
                    </h2>
                    <p className="niche-cta-description">
                        {t('freelancers.ctaDescription')}
                    </p>
                    <Buttons />
                </div>
            </section>
        </>
    );
}

export default Features;